<template>
<div id="check_link">
    <Material  :user.sync="user" :city.sync="city" :auth.sync="auth" v-if="isCategory === 1"/>
    <Category  :user.sync="user" :city.sync="city" :auth.sync="auth" v-if="isCategory === 2"/>
</div>
</template>

<script>
import axios from '@/router/http'
import Category from '@/components/Category'
import Material from '@/components/Material'
export default {
  name: 'CheckLink',
  props: ['city', 'user', 'auth'],
  data () {
    return {
      isCategory: 0,
      data: {}
    }
  },
  created () {
    axios.get('https://crm.v-avtoservice.com/list/site-check-page?link=' + window.location.pathname).then(response => {
      if (response.data.is === 'cat') this.isCategory = 2; else if (response.data.is === 'article') this.isCategory = 1; else this.isCategory = 0
    })
  },
  watch: {
    $route (to, from) {
      axios.get('https://crm.v-avtoservice.com/list/site-check-page?link=' + to.path).then(response => {
        if (response.data.is === 'cat') this.isCategory = 2; else if (response.data.is === 'article') this.isCategory = 1; else this.isCategory = 0
      })
    }
  },
  components: {
    Category,
    Material
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CheckLink.vue